import React, { FC, useMemo } from 'react';
import { Stack } from '@fiverr-private/layout_components';
import { Heading } from '@fiverr-private/typography';
import { appTranslate } from '../../i18n';
import { WorkExperience as WorkExperienceType, CompanyProfile } from '../../gql-operations/gql-generated';
import { getVisibleExperiences } from './utils/workExperienceUtils';
import { WorkExperienceList } from './WorkExperienceList';

export interface WorkExperienceData extends Omit<Partial<WorkExperienceType>, 'company'> {
    id: string;
    title: string;
    company?: Partial<CompanyProfile> | null;
}

export interface WorkExperienceProps {
    workExperiences: WorkExperienceData[];
    showAll?: boolean;
    maxVisibleItems?: number;
    noHeader?: boolean;
}

export const WorkExperience: FC<WorkExperienceProps> = ({
    workExperiences,
    showAll = false,
    maxVisibleItems = 3,
    noHeader = false,
}) => {
    const experiencesToRender = useMemo(
        () => getVisibleExperiences(workExperiences, showAll, maxVisibleItems),
        [workExperiences, showAll, maxVisibleItems]
    );

    if (!workExperiences.length) {
        return null;
    }

    return (
        <Stack direction="column" gap="6">
            {!noHeader && <Heading as="h4">{appTranslate('WorkExperience.title')}</Heading>}

            <WorkExperienceList experiences={experiencesToRender} />
        </Stack>
    );
};
